import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteCertTemplate } from "../../store/certificates/actions";
export var useApiDeleteCertificate = function (trigger, certId, userId) {
    var dispatch = useDispatch();
    var body = {
        force: false
    };
    var _a = useSelector(function (state) { return ({
        loadingPatchCertTemplate: state.Certificates.loadingPatchCertTemplate,
        responsePatchCertTemplate: state.Certificates.responsePatchCertTemplate,
        errorPatchCertTemplate: state.Certificates.errorPatchCertTemplate,
    }); }), loadingPatchCertTemplate = _a.loadingPatchCertTemplate, responsePatchCertTemplate = _a.responsePatchCertTemplate, errorPatchCertTemplate = _a.errorPatchCertTemplate;
    useEffect(function () {
        if (trigger) {
            dispatch(deleteCertTemplate(certId, userId, body));
        }
    }, [trigger]);
    return {
        loadingPatchCertTemplate: loadingPatchCertTemplate,
        responsePatchCertTemplate: responsePatchCertTemplate,
        errorPatchCertTemplate: errorPatchCertTemplate,
    };
};
